<template>
  <v-dialog persistent :fullscreen="$vuetify.breakpoint.xsOnly" @keydown.prevent.stop.esc="closeDlg" :scrollable="true"
    :content-class="isMobileOnly ? 'app-dialog sign-dialog mobile' : 'app-dialog sign-dialog'" :max-width="maxWidth"
    :value="isDialogVisible" eager :retain-focus="false">

    <v-card class="elevation-0">

      <v-toolbar class="app-dialog-header">
        <v-toolbar-title>{{$t(dlgHeader)}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon small @click="closeDlg">
          <v-icon small>fa-times</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="app-dialog-body pa-0" style="height: 100%">
        <v-card-subtitle v-if="isDialogSubtitleVisible" class="px-4 pt-2 pb-0">
          <div v-html="dialogSubtitleHtml"></div>
        </v-card-subtitle>
        <app-sign v-if="isSignComponentRendered" class="px-4 py-2" :eventBus="childrenEventBus"
          @buttons-settings-changed="onButtonsSettingsChanged"></app-sign>
      </v-card-text>

      <v-card-actions class="app-dialog-footer d-block elevation-0">
        <v-row no-gutters>
          <v-col cols="12 d-flex">
            <v-btn v-if="isResetBtnVisible" :disabled="isResetBtnDisabled" color="secondary" @click="clearKey">
              {{$t('buttons.removesign')}}</v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="isSignBtnDisabled" color="primary" @click="sign">
              {{ $t(signButtonText) }}
            </v-btn>
            <v-btn v-if="!isMobileOnly" class="ml-2" color="secondary" @click="closeDlg">{{$t('buttons.close')}}</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>

  </v-dialog>

</template>

<script>
import Vue from 'vue';

import uiMixin from '@/mixins/ui-mixin';
import AppSign from './AppSign';
import { signService } from '@/sign/services/sign.service';

export default {
  name: 'AppSignDlg',
  components: { AppSign },
  mixins: [uiMixin],
  inject: ['isMobileOnly'],
  data() {
    return {
      dlgHeader: '',
      isDialogVisible: false,
      isSignComponentRendered: false,
      signButtonText: '',
      dialogSubtitleHtml: '',
      isDialogSubtitleVisible: false,
      childrenEventBus: new Vue(),
      isResetBtnVisible: true,
      isResetBtnDisabled: true,
      isSignBtnDisabled: true,
      isSealSelectorVisible: false
    };
  },
  computed: {
    maxWidth() {
      let bp = this.$vuetify.breakpoint;
      return this.isSealSelectorVisible
        ? (bp.sm ? '90vw' : bp.md ? '70vw' : bp.lg ? '60vw' : '50vw')
        : (bp.sm ? '70vw' : bp.md ? '50vw' : bp.lg ? '40vw' : '30vw');
    }
  },
  mounted() {
    this.subscribe();
  },
  methods: {
    clearKey() {
      this.childrenEventBus.$emit('app-sign-reset-private-key');
    },
    closeDlg() {
      this.isDialogVisible = false;
      signService.cancelSigning();
    },
    async sign() {
      this.childrenEventBus.$emit('app-sign-execute-sign');
    },
    subscribe() {
      this.$eventBus.$on('app-sign-show-sign-dlg', () => {
        this.childrenEventBus.$emit('app-sign-prepare');
        const sett = signService.getCurrentSettings();
        this.signButtonText = sett.submitBtnText || 'buttons.sign';
        this.dlgHeader = sett.dialogHeader || 'appSignDlg.title';
        this.dialogSubtitleHtml = sett.dialogSubtitleHtml;
        this.isDialogSubtitleVisible = !!this.dialogSubtitleHtml;
        this.isSignComponentRendered = true;
        this.isDialogVisible = true;
      });
      this.$eventBus.$on(
        'app-sign-hide-sign-dlg',
        () => (this.isDialogVisible = false)
      );
    },
    onButtonsSettingsChanged({
      isResetBtnVisible,
      isResetBtnDisabled,
      isSignBtnDisabled,
      isSealAdded
    }) {
      this.isResetBtnVisible = isResetBtnVisible;
      this.isResetBtnDisabled = isResetBtnDisabled;
      this.isSignBtnDisabled = isSignBtnDisabled;
      this.isSealSelectorVisible = isSealAdded;
    }
  }
};
</script>

<style lang="scss">
.sign-dialog {
  &:not(.mobile) {
    min-width: 500px;
  }
}
</style>
